import {
  SET_LAST_ACTIVE,
  SET_TOKEN,
  SET_ERROR,
  SET_LAST_REFRESHED,
  SET_IS_REFRESHING,
  SET_LAST_CLICKED,
} from '../../constants';

const initialState = {
  lastActive: null,
  lastRefreshed: null,
  token: sessionStorage.getItem('token'),
  error: null,
  isRefreshing: false,
  lastClicked: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LAST_ACTIVE:
      return { ...state, lastActive: action.lastActive };
    case SET_LAST_REFRESHED:
      return { ...state, lastRefreshed: action.lastRefreshed };
    case SET_TOKEN:
      return { ...state, token: action.token };
    case SET_ERROR:
      return { ...state, error: action.error };
    case SET_IS_REFRESHING:
      return { ...state, isRefreshing: action.isRefreshing };
    case SET_LAST_CLICKED:
      return { ...state, lastClicked: action.time };
    default:
      return state;
  }
};

export default authReducer;
